import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment, useState } from "react";

interface DeleteChartConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
}

export const DeleteChartConfirmDialog: React.FC<
  DeleteChartConfirmDialogProps
> = ({ isOpen, onClose, onDelete }) => {
  const [input, setInput] = useState<string>("");

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-10 overflow-y-auto"
        onClose={onClose}
      >
        <div className="min-h-screen text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-700"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-500"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-30 transition-opacity" />
          </Transition.Child>

          <span
            className="inline-block h-screen align-middle"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className="p-10 inline-block w-full max-w-md overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-md">
              <Dialog.Title className="uppercase text-2xl text-primary-blue font-semibold tracking-wide">
                Confirm item deletion
              </Dialog.Title>
              <div className="mt-4">
                <p className="text-sm text-gray-500">
                  Type in{" "}
                  <span className="text-blue-700 bg-blue-100">delete</span> to
                  confirm your actions
                </p>
              </div>

              <div className="flex flex-col mt-4 gap-4">
                <input
                  type="text"
                  autoComplete="off"
                  maxLength={6}
                  className="w-full placeholder:text-base placeholder:font-poppins placeholder:font-normal font-sourceSansPro font-bold text-xl text-center bg-white block px-[15px] py-[12px] border border-primary-blue rounded-md focus:outline-none focus:ring-1 focus:ring-primary-blue"
                  onChange={(e) => setInput(e.target.value)}
                />
                <button
                  className="tracking-wider justify-center items-center px-6 py-3 text-white border border-primary-blue text-base font-semibold rounded-md shadow-sm bg-primary-blue focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 disabled:opacity-25"
                  type="submit"
                  disabled={input.toLowerCase() !== "delete"}
                  onClick={onDelete}
                >
                  DELETE
                </button>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};
